import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/auth/services/auth.service';
import { BlogsComponent } from 'src/app/shared/components/blogs/blogs.component';
import { NewsComponent } from 'src/app/shared/components/news/news.component';
import { IBaseBlogsRequest, IBaseNewsRequest, IBlogs, IBlogsDeleteAllRequest, IBlogsUpdateRequest, INews, INewsDeleteAllRequest, INewsUpdateRequest, NewsBlogsService } from 'src/app/shared/services/news-blogs.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { TranslationService } from 'src/app/shared/services/translation.service';


@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  standalone: false
})
export class MessagesComponent  implements OnInit {

  //title: string = 'Nav.Support';
  //currentSegment: string = 'contact';

  newsRequest: IBaseNewsRequest;
  blogsRequest: IBaseBlogsRequest;
  updateNewsRequest: INewsUpdateRequest;
  updateBlogsRequest: IBlogsUpdateRequest;
  deleteAllNewsRequest: INewsDeleteAllRequest;
  deleteAllBlogsRequest: IBlogsDeleteAllRequest;

  //news: any[] = [];
  //blogs: any[] = [];

  blogsCategories: IBlogs[] = [];
  newsCategories: INews[] = [];

  constructor(
    private modalCtrl: ModalController,
    private settingService: SettingService,
    private newsBlogService: NewsBlogsService,
    public translationService: TranslationService,
    public authservice: AuthService
  ) { }

  ngOnInit() {
    console.log(this.translationService.getLanguage())
    this.getAllNews();
    this.getAllBlogs();

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();
  }

  getAllNews(){
    this.fetchNews().subscribe(async newsCat => {
      this.newsCategories = newsCat;

      for(var i = 0; i < this.newsCategories.length; i++) {
        var category = this.newsCategories[i];

        for(var y = 0; y < category.news.length; y++) {
          var news = category.news[y];

          news.images['imgURL'] = await this.newsBlogService.fetchImage(news.images.imgShortName);
          news.images['imgMobileURL'] = await this.newsBlogService.fetchImage(news.images.imgMobileShortName);
        }
      }

    });
  }

  fetchNews() {

    if(this.authservice.isAuthenticated) {
      this.newsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: this.authservice.memberId.toString()
      }
    } else {
      this.newsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: ""
      }
    }

    return this.newsBlogService.getNews(this.newsRequest);
  }


  getAllBlogs(){
    this.fetchBlogs().subscribe(async blogs => {
      this.blogsCategories = blogs;

      for(var i = 0; i < this.blogsCategories.length; i++) {
        var category = this.blogsCategories[i];

        for(var y = 0; y < category.blogs.length; y++) {
          var blog = category.blogs[y];

          blog.images['imgURL'] = await this.newsBlogService.fetchImage(blog.images.imgShortName);
          blog.images['imgMobileURL'] = await this.newsBlogService.fetchImage(blog.images.imgMobileShortName);
        }
      }
      
      /*
      this.blogs = [];

      this.blogs = blogs;
      
      
      for(var i = 0; i < blogs.length; i++){
        // inject the image URL in each promotions
        this.blogs[i].images['imgURL'] = await this.newsBlogService.fetchImage(blogs[i].images.imgShortName);
        this.blogs[i].images['imgMobileURL'] = await this.newsBlogService.fetchImage(blogs[i].images.imgMobileShortName);
      }

      console.log(blogs);
      */
    });
  }

  fetchBlogs() {
    if(this.authservice.isAuthenticated) {
      this.blogsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: this.authservice.memberId.toString()
      }
    } else {
      this.blogsRequest = {
        merchantId: this.settingService.getMerchantId(),
        userId: ""
      }
    }

    return this.newsBlogService.getBlogs(this.blogsRequest);
  }

  getnewsImage(news){
    /*
    if(this.mobile) {
      if(promotion.visualConfig){
        if(promotion.visualConfig.imgMobileURL) {
          const url = promotion.visualConfig.imgMobileURL;
          return url;
        }     
      }
    } else {
      if(promotion.visualConfig){
        if(promotion.visualConfig.imgURL) {
          const url = promotion.visualConfig.imgURL;
          return url;
        }     
      }
    }
    */
   if(news.images){
      if(news.images.imgURL) {
        const url = news.images.imgURL;
        return url;
      }     
    }
  }

  getblogsImage(blogs){
    /*
    if(this.mobile) {
      if(promotion.visualConfig){
        if(promotion.visualConfig.imgMobileURL) {
          const url = promotion.visualConfig.imgMobileURL;
          return url;
        }     
      }
    } else {
      if(promotion.visualConfig){
        if(promotion.visualConfig.imgURL) {
          const url = promotion.visualConfig.imgURL;
          return url;
        }     
      }
    }
    */
   if(blogs.images){
      if(blogs.images.imgURL) {
        const url = blogs.images.imgURL;
        return url;
      }     
    }
  }

  async showmorenews(news) {
    // setup a modal opening to the "news" component

    const modal = await this.modalCtrl.create({
      component: NewsComponent,
      cssClass: 'news-model',
      componentProps: {
        news: news
      }
    });
  
    modal.onWillDismiss()
      .then((result) => {
        
    });
  
    await modal.present();
  }

  deletenews(news) {
    // delete the specified news passing through

    this.deleteNews(news).subscribe(async completedDeletion => {
      if(completedDeletion) {
        this.getAllNews();
      }
    });
  }

  deleteNews(news) {
    this.updateNewsRequest = {
      merchantId: this.settingService.getMerchantId(),
      userId: this.authservice.memberId.toString(),
      newsId: news.id,
      status: "deleted"
    }

    return this.newsBlogService.updateNews(this.updateNewsRequest);
  }

  async showmoreblog(blog) {
    // setup a modal opening to the "blogs" component

    const modal = await this.modalCtrl.create({
      component: BlogsComponent,
      cssClass: 'blogs-model',
      componentProps: {
        blog: blog
      }
    });
  
    modal.onWillDismiss()
      .then((result) => {
        
    });
  
    await modal.present();
  }

  deleteblogs(blog) {
    // delete the specified blog passing through
    this.deleteBlog(blog).subscribe(async completedDeletion => {
      if(completedDeletion) {
        this.getAllBlogs();
      }
    });
  }

  deleteBlog(blog) {
    this.updateBlogsRequest = {
      merchantId: this.settingService.getMerchantId(),
      userId: this.authservice.memberId.toString(),
      blogId: blog.id,
      status: "deleted"
    }

    return this.newsBlogService.updateBlogs(this.updateBlogsRequest);
  }

  

  deleteall() {
    // use the "this.news" and "this.blogs" and just remove all of them via the API
    this.deleteAllBlogs().subscribe(async completedDeletion => {
      if(completedDeletion) {
        this.getAllBlogs();
      }
    });

    this.deleteAllNews().subscribe(async completedDeletion => {
      if(completedDeletion) {
        this.getAllNews();
      }
    });
  }

  deleteAllBlogs() {
    var blogsList = [];
    for(var i = 0; i < this.blogsCategories.length; i++) {
      var category = this.blogsCategories[i];

      for(var y = 0; y < category.blogs.length; y++) {
        var blog = category.blogs[y];

        blogsList.push({
          blogsId: blog.id,
          status: "deleted"
        });
      }
    }

    this.deleteAllBlogsRequest = {
      merchantId: this.settingService.getMerchantId(),
      userId: this.authservice.memberId.toString(),
      blogList: blogsList,
    }

    return this.newsBlogService.deleteAllBlogs(this.deleteAllBlogsRequest);
  }

  deleteAllNews() {
    var newsList = [];
    for(var i = 0; i < this.newsCategories.length; i++) {
      var category = this.newsCategories[i];

      for(var y = 0; y < category.news.length; y++) {
        var news = category.news[y];

        newsList.push({
          newsId: news.id,
          status: "deleted"
        });
      }
    }

    this.deleteAllNewsRequest = {
      merchantId: this.settingService.getMerchantId(),
      userId: this.authservice.memberId.toString(),
      newsList: newsList,
    }

    return this.newsBlogService.deleteAllNews(this.deleteAllNewsRequest);
  }


  closePopup(){
    //if(this.isPopup) {
      this.modalCtrl.dismiss();
    //}
  }
}
